export const SenderIDValidator = {
  sender_id: {
    maxLength: 11,
    pattern: /^[A-Za-z0-9 ]+$/,
    required: true
  },
  company_name: {
    required: true
  },
  use_case: {
    required: true
  }
};
